import moment from "jalali-moment";
const ConvertDate = (Orginaldate) => {
  const convertedtDate = new Date(parseInt(Orginaldate)); //unix typr
  const persianDate = moment(convertedtDate, "YYYY/MM/DD")
    .locale("fa")
    .format("YYYY/MM/DD");
  return <>{persianDate}</>;
};

export default ConvertDate;
